import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { STYLES } from '../../static/style'
import { isNil } from '../../lib/ramda'

const StyledSchoolSearchResultsToolbar = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${STYLES.COLOR_OUTER_SPACE_GRAY};
`

const TotalResults = styled.div`
  color: ${STYLES.PRIMARY_COLOR};
  font-weight: ${STYLES.FONT_WEIGHT_BOLD};
  justify-content: space-between;
`

const TotalResultsTitle = styled.span`
  font-weight: ${STYLES.FONT_WEIGHT_BOLD};
`

const TotalResultsText = styled.span`
  font-weight: ${STYLES.FONT_WEIGHT_LITE};
`

const SchoolSearchResultsToolbar = () => {
  const { count } = useSelector((state) => state.schools)
  if (isNil(count)) {
    return null
  }
  return (
    <StyledSchoolSearchResultsToolbar>
      <TotalResults>
        <TotalResultsTitle>Total:&nbsp;</TotalResultsTitle>
        <TotalResultsText>{count}</TotalResultsText>
      </TotalResults>
    </StyledSchoolSearchResultsToolbar>
  )
}

export { SchoolSearchResultsToolbar }
